import { useEffect, useState, useContext, useRef } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import AuthContext from "../../../../auth/AuthContext";
import AlertService from "../../../../services/AlertService";
import { FaTrash } from "react-icons/fa";
import DocumentTypeService from "../../../../services/DocumentTypeService";
import ConfirmDialogBox from "../../../confirmDialog/ConfirmDialogBox";

const AddDocTypeModal = ({
  show,
  handleClose,
  isEditMode,
  initialDocType,
  reloadList,
}) => {
  const authContext = useContext(AuthContext);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [documentType, setDocumentType] = useState("");
  const submitControllerRef = useRef(null);
  // const [category, setCategory] = useState('');
  // const [customCategory, setCustomCategory] = useState('');

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(0);

  useEffect(() => {
    if (isEditMode && initialDocType) {
      setDocumentType(initialDocType.documentType || "");
      setId(initialDocType.id || 0);
    } else {
      resetForm();
    }
  }, [isEditMode, initialDocType, show]);



  const resetForm = () => {
    setDocumentType("");
    setErrors({});
    setId(0);
  };

  const onClose = () => {
    resetForm();
    handleClose();
  };

  const validateForm = () => {
    const newErrors = {};
    if (!documentType.trim()) newErrors.documentType = "Please enter document type";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



const handleSubmit = async () => {
  if (!validateForm()) return;

  if (submitControllerRef.current) {
    submitControllerRef.current.abort();
  }
  const controller = new AbortController();
  submitControllerRef.current = controller;

  setLoading(true);

  const payload = {
    documentType: documentType,
  };
  if (isEditMode && id > 0) {
    payload.id = id;
  }

  try {
    const data = await DocumentTypeService.Save(
      payload,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (data.isSuccess) {
      AlertService.success("Document type saved successfully!");
      resetForm();
      handleClose();
      reloadList();
    } else {
      AlertService.error(data.errorMessage);
    }
  } catch (err) {
    if (err.name === "AbortError") return;
    AlertService.error("Failed to save document type");
  } finally {
    if (!controller.signal.aborted) setLoading(false);
  }
};

  // Unmount cleanup
useEffect(() => {
  return () => {
    submitControllerRef.current?.abort();
  };
}, []);

  const handleDelete = async () => {
    if (id > 0) {
      const data = await DocumentTypeService.Remove(id, authContext);
      if (data.isSuccess) {
        AlertService.success("Document type deleted successfully!");
        setShowDeleteDialog(false);
        resetForm();
        reloadList();
      } else {
        AlertService.error(data.errorMessage);
      }
    }
  };


  return (
    <>
      <Modal show={show} onHide={onClose} backdrop="static" centered size="xl">
        <Modal.Header closeButton className="border-0 pt-3">
          <Modal.Title>{isEditMode ? "Edit Document Folder" : "Add New Document Folder"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Document Folder</Form.Label>
              <Form.Control
                type="text"
                className="custom-input custom-input-color"
                placeholder="Enter Document Folder"
                value={documentType}
                onChange={(e) => setDocumentType(e.target.value)}
                disabled={loading}
              />
              {errors.documentType && <div className="text-danger">{errors.documentType}</div>}
            </Form.Group>

            {/* <Form.Group className="mb-3">
              <Form.Label>Under</Form.Label>
              <select
                className="form-select custom-input"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="">Select Document Category</option>
                <option value="HAND BOOKS">Hand Books</option>
                <option value="PRESENTATION">Presentation</option>
                <option value="EXERCISE">Exercise</option>
                <option value="FAQS">FAQs</option>
                <option value="OTHER">Other Documents</option>
              </select>
            </Form.Group> */}

            {/* {category === 'OTHER' && (
              <Form.Group className="mb-3">
                <Form.Label>Enter Custom Category</Form.Label>
                <Form.Control
                  type="text"
                  className="custom-input"
                  placeholder="Enter your custom category"
                  value={customCategory}
                  onChange={(e) => setCustomCategory(e.target.value)}
                />
              </Form.Group>
            )} */}

          </Form>
        </Modal.Body>

        <Modal.Footer className="border-0 pb-4 px-4">
          <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
            {isEditMode && (
              <div
                className="text-danger d-flex align-items-center"
                onClick={() => {
                  handleClose();
                  setTimeout(() => {
                    setShowDeleteDialog(true);
                  }, 300);
                }}
                style={{ fontWeight: 500, cursor: "pointer" }}
              >
                <FaTrash className="me-2" size={20} />
                Delete
              </div>
            )}

            <div className="ms-auto d-flex gap-3">
              <Button
                variant="outline-secondary"
                className="px-5 py-2"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="px-5 py-2"
                onClick={handleSubmit}
                disabled={loading}
              >
                {isEditMode ? "Update" : "Submit"}
              </Button>
            </div>
          </div>
        </Modal.Footer>


      </Modal>
      <ConfirmDialogBox
        visible={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        onConfirm={handleDelete}
        title={
          <>
            Are you sure you want to delete the document folder <strong>{documentType}</strong>?
          </>
        }
        confirmLabel="Yes, Delete"
        cancelLabel="Cancel"
      />


    </>
  );
};

export default AddDocTypeModal;
